// @ts-nocheck
import React from 'react';

const Section1 = ({ photo }) => {
  return (
    <>
      <section className="pb-5">
        <div className="relative flex gap-10 max-md:flex-col">
          <img className="object-cover w-full rounded-xl" src={photo} alt="" />
        </div>
      </section>
    </>
  );
};

export default Section1;
